var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.545854 9.49565C0.318049 9.26784 0.318049 8.8985 0.545854 8.67069L4.21671 4.99984L0.545854 1.32898C0.318049 1.10118 0.318049 0.73183 0.545854 0.504025C0.77366 0.276218 1.14301 0.276218 1.37081 0.504025L5.45415 4.58736C5.68195 4.81516 5.68195 5.18451 5.45415 5.41232L1.37081 9.49565C1.14301 9.72346 0.77366 9.72346 0.545854 9.49565Z",
    fill: "#003193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronRight);
export default __webpack_public_path__ + "static/media/ic-chevron-right.fd3c8833bcc6c6c6827a0c39465e9864.svg";
export { ForwardRef as ReactComponent };